export default __webpack_public_path__ + "static/media/dummyImage.0d14c699.png";